// extracted by mini-css-extract-plugin
export default {"container":"LocationBadges_container__gMNVW"};